"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderDocumentUpload = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const useAnalytics_1 = require("../../../hooks/useAnalytics");
const uploadDocument_1 = require("../api/uploadDocument");
const ActivityFeedContext_1 = require("../components/ActivityFeedContext");
const DocumentsUploadDialog_1 = require("../components/DocumentsUploadDialog");
const UploadIconButton = ({ onClick }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Tooltip, { title: translate('frontend-sdk_upload_document_tooltip'), children: (0, jsx_runtime_1.jsx)(silhouette_core_1.IconButton, { onClick: onClick, "data-e2e-id": "show_upload_modal-button", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.NoteAddIcon, { color: "action" }) }) }));
};
const useRenderDocumentUpload = (isDocumentsUploadEnabled, uploadDocumentButton) => {
    const { mainEntity } = (0, ActivityFeedContext_1.useActivityFeedState)();
    const snack = (0, frontend_infra_snack_1.useSnackService)();
    const { uploadDocument } = (0, uploadDocument_1.useUploadDocumentAPI)(mainEntity.id);
    const { sendEvent } = (0, useAnalytics_1.useAnalytics)();
    const [isUploadDialogOpen, setIsUploadDialogOpen] = (0, react_1.useState)(false);
    if (!isDocumentsUploadEnabled) {
        return { uploadButton: null, uploadDialog: null };
    }
    const handleError = (error) => {
        snack.showError(error);
    };
    const handleUploadFile = async (file, type) => {
        sendEvent('activity-feed-document-upload', { type });
        return uploadDocument(file, type);
    };
    return uploadDocumentButton
        ? { uploadButton: uploadDocumentButton, uploadDialog: null }
        : {
            uploadButton: (0, jsx_runtime_1.jsx)(UploadIconButton, { onClick: () => setIsUploadDialogOpen(true) }),
            uploadDialog: ((0, jsx_runtime_1.jsx)(DocumentsUploadDialog_1.DocumentsUploadDialog, { upload: (file, _, fileType) => handleUploadFile(file, fileType), open: isUploadDialogOpen, closeDialog: () => setIsUploadDialogOpen(false), handleError: handleError })),
        };
};
exports.useRenderDocumentUpload = useRenderDocumentUpload;
//# sourceMappingURL=useRenderDocumentUpload.js.map